
export default {
    name: 'AndroidIcon',
};
